import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import {
  DonutChartOptionsProps,
  donutChartOptions,
} from '@features/campaigns/subdomains/visitation/configuration/donutChartOptions';
import { Stack } from '@mui/material';
import { ChartTitle } from './ChartTitle';

type DonutChartWithTitleProps = DonutChartOptionsProps & {
  title: string;
};

export const DonutChartWithTitle = (props: DonutChartWithTitleProps) => {
  const { title, ...donutChartOptionsProps } = props;
  return (
    <Stack direction="column" gap="1rem">
      <ChartTitle title={title} />
      <HighchartsReact
        highcharts={Highcharts}
        options={donutChartOptions(donutChartOptionsProps)}
      />
    </Stack>
  );
};
